<div class="layout-sidebar">
  @let config = (config$ | async)!;
  <a [routerLink]="['/']" class="logo py-2">
    <div class="logo-image flex w-full items-center justify-center">
      @if (isStatic(config)) {
        <img class="horizontal-logo h-full max-h-12 w-auto" [routerLink]="['/']" [src]="logoSrc" alt="RGS+" />
      }
      @if (isCompact(config)) {
        <img
          class="horizontal-logo w-full max-w-12"
          [routerLink]="['/']"
          [src]="'assets/layout/images/logo-RGS-sq.png'"
          alt="RGS+"
        />
      }
    </div>
  </a>
  <div class="layout-menu-container">
    <app-menu></app-menu>
  </div>

  @if (buildInfoResource.isLoading()) {
    <span class="flex p-4">
      <p-skeleton height="1rem" width="3rem" />
    </span>
  } @else {
    @let version = $safeNavigationMigration(buildInfoResource.value()?.version);
    @let commitHash = $safeNavigationMigration(buildInfoResource.value()?.commitHash);

    @if (version && commitHash) {
      <span class="flex p-4">
        <a [href]="changelogUrl" target="_blank" class="cursor-pointer text-white/80 underline hover:text-white">
          v{{ version }}-{{ commitHash }}
        </a>
      </span>
    }
  }
</div>
